import '@/assets/css/tailwind.css';
import '@inexture/core/styles.css';
import '@inexture/carousel/styles.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App.tsx';

import { ThemeProvider } from '@inexture/core/providers';
import { ModalsProvider } from '@inexture/modals';

import { theme } from '@/theme';
import { Provider } from 'react-redux';
import { persistor, store } from '@/store';
import { PersistGate } from 'redux-persist/integration/react';

// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';

// import {
//   AllCommunityModule,
//   ModuleRegistry,
//   provideGlobalGridOptions
// } from 'ag-grid-community';

// ModuleRegistry.registerModules([AllCommunityModule]);
// provideGlobalGridOptions({
//   theme: 'legacy'
// });

const appRoot = document.getElementById('app');

if (appRoot) {
  appRoot?.setAttribute('notranslate', 'true');
}

ReactDOM.createRoot(appRoot!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider props={{ theme: theme, defaultColorScheme: 'light' }}>
          <ModalsProvider>
            <App />
          </ModalsProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
